<template>
<div
    class="ui-tab-pane"
    v-if="defaultActive || ((active || rendered) && (forceRender || active))"
    v-show="active"
    role="tabpanel"
>
    <!-- 面板内容 -->
    <slot :active="active"/>
</div>

</template>
<script>
import {bemMixin, hasProp} from "../utils";
export default {
  name: "g-tab-panel",
  mixins: [bemMixin],
  props: {
    activeKey: {
      type: [String, Number],
      default: null
    },
    defaultActive: {
      type: Boolean,
      default: false
    },
    forceRender: {
      type: Boolean,
      default: false
    },
    tab: {
      type: [String, Object, Function],
      required: true
    },
    closable: Boolean,
    disabled: Boolean
  },
  data() {
    return {
      rendered: false
    };
  },
  computed: {
    value() {
      if (hasProp(this, "activeKey")) {
        return this.activeKey;
      }
      return this.tab;
    },
    active() {
      return this.value === this.$parent.innerActiveKey;
    }
  },
  watch: {
    active() {
      if (this.active)
        this.rendered = true;
    }
  },
  mounted() {
    if (this.active) {
      this.rendered = true;
    }
  }
};

</script>
